import { SurveyIntro } from "./SurveyIntro";
export default SurveyIntro;
